<template>
  <v-container>
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />
    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-1"
    />
  </v-container>
</template>
<style lang="scss" scoped>
::v-deep .img-lavora-con-noi {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    img {
      width: 30%;
      margin-right: auto;
      margin-left: auto;
      display: block;
    }
  }
  @media #{map-get($display-breakpoints, 'sm-only')} {
    img {
      width: 100%;
    }
  }
}
::v-deep .header-img-cnt {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    text-align: center;
  }
}
</style>
<script>
import category from "~/mixins/category";

export default {
  name: "WorkWithUs",
  props: {},
  components: {},
  mixins: [category],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  async mounted() {}
};
</script>
